import { useRemoteSync } from '../hooks/useRemoteSync';

// Mantém o app como fonte da verdade: publica o estado e aplica comandos do remoto.
export function RemoteSync() {
  useRemoteSync();
  return null;
}
